<template>
    <div>
        <PriceSpecificationActivity :product="product" />
    </div>
</template>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { ActivityProduct } from '@/api/Cart/cart.interfaces';
    import PriceSpecificationActivity from '@/components/shared/PriceSpecification/Activity/PriceSpecificationActivity.vue';

    export default defineComponent({
        name: 'ActivityModalPrice',
        components: { PriceSpecificationActivity },
        props: {
            product: {
                type: Object as PropType<ActivityProduct>,
                required: true,
            },
        },
    });
</script>
